import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { Button } from 'reactstrap';

interface InlineQuillEditorProps {
  value: string;
  minHeight: number;
  onSave: (value: string) => void;
  onCancel: () => void;
  toolbar?: any;
}

const defaultToolbar = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }],
  [{ size: ['small', false, 'large', 'huge'] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ['clean'],
];

const InlineQuillEditor: React.FC<InlineQuillEditorProps> = ({
  value,
  minHeight,
  onSave,
  onCancel,
  toolbar = defaultToolbar,
}) => {
  const quillRef = useRef<HTMLDivElement>(null);
  const quillInstance = useRef<any>(null);

  useEffect(() => {
    if (quillRef.current && !quillInstance.current) {
      quillInstance.current = new Quill(quillRef.current, {
        theme: 'snow',
        modules: { toolbar },
      });
      quillInstance.current.clipboard.dangerouslyPasteHTML(value || '');
    }
    return () => {
      quillInstance.current = null;
      if (quillRef.current) quillRef.current.innerHTML = '';
    };
  }, [value, toolbar]);

  const handleSave = () => {
    if (quillInstance.current) {
      onSave(quillInstance.current.root.innerHTML);
    }
  };

  return (
    <div className="flex-1">
      <div
        className="border rounded bg-white overflow-auto"
        style={{
          minHeight,
          width: '100%',
          wordBreak: 'break-word',
        }}
      >
        <div ref={quillRef} />
      </div>
      <div className="mt-2 flex gap-2">
        <Button color="primary" size="sm" onClick={handleSave} className="me-2">
          Save
        </Button>
        <Button color="secondary" size="sm" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default InlineQuillEditor; 